<template>
	<div
		class="tile"
	>
		<h2><translate>Finances</translate></h2>
		<div v-if="statusMessage !== null">
			<v-row no-gutters>
				<v-col
					style="padding-right: 4px"
					cols="auto"
				>
					<translate>Status</translate>:
				</v-col>
				<v-col cols="auto">
					<v-img
						class="hover-img"
						:src="statusImage"
						:min-width="imageSize"
						:min-height="imageSize"
						:title="$gettext(statusMessage)"
					/>
				</v-col>
				<v-col cols="auto">
					<v-img
						v-if="secondStatusImage"
						class="hover-img"
						:src="secondStatusImage"
						:min-width="imageSize"
						:min-height="imageSize"
						:title="$gettext(secondStatusMessage)"
					/>
				</v-col>
			</v-row>
			<v-row no-gutters>
				<v-col
					style="padding-right: 4px"
					cols="auto"
				>
					<translate>Debit date</translate>:
				</v-col>
				<v-col cols="auto">
					{{ dueDate }}
				</v-col>
			</v-row>
			<v-row no-gutters>
				<v-col cols="auto">
					<translate>Amount</translate>: €
				</v-col>
				<v-col cols="auto">
					{{ amount }}
				</v-col>
			</v-row>
			<v-row no-gutters>
				<v-col
					style="padding-right: 4px"
					cols="auto"
				>
					<translate>IBAN</translate>:
				</v-col>
				<v-col cols="auto">
					{{ bankAccount }}
				</v-col>
			</v-row>
			<div class="tile_btns">
				<a
					class="btn btn-info btn-xs"
					href="/dashboard/invoices"
				><translate>View my invoices</translate></a>
			</div>
		</div>
		<div v-else>
			<translate>You have no invoices at this time</translate>.
		</div>
	</div>
</template>

<script>
export default {
	name: 'DashboardFinances',
	props: {
		statusImage: {
			type: String,
			default: null
		},
		statusMessage: {
			type: String,
			default: null
		},
		secondStatusImage: {
			type: String,
			default: null
		},
		secondStatusMessage: {
			type: String,
			default: null
		},
		dueDate: {
			type: String,
			default: null
		},
		amount: {
			type: String,
			default: null
		},
		bankAccount: {
			type: String,
			default: null
		},
	},
	data () {
		return {
			imageSize: 20,
			hover: false,
			secondHover: false,
		};
	}
};
</script>
